module.exports={
	"Hash": "plansheet-blueprint",
	"Name": "Blueprint",
	"Version": "1.0.0",
	"Description": "Deep Prussian ground with white-blue linework, the cyanotype a plan sheet becomes. Amber stays measurement ink. A dark theme in every light.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "single",
		"Default": "dark"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   "#0E315F",
				"Secondary": "#123A6E",
				"Tertiary":  "#16427B",
				"Panel":     "#123A6E",
				"Hover":     "#1A4A85",
				"Selected":  "#1E5494"
			},
			"Text": {
				"Primary":     "#EAF2FC",
				"Secondary":   "#C7D9EF",
				"Muted":       "#9FB8D8",
				"Placeholder": "#6E8AB3"
			},
			"Brand": {
				"Primary":      "#9CC6F5",
				"PrimaryHover": "#B7D7F9",
				"Accent":       "#F2C84B"
			},
			"Border": {
				"Default": "#2F5B99",
				"Light":   "#1D4677",
				"Strong":  "#4E7BB8"
			},
			"Status": {
				"Success": "#6FCB87",
				"Warning": "#F2C84B",
				"Error":   "#F08A7E",
				"Info":    "#9CC6F5"
			},
			"Scrollbar": {
				"Track": "#0B2A52",
				"Thumb": "#275489",
				"Hover": "#3A6AA6"
			},
			"Selection": {
				"Background": "#2A5CA0",
				"Text":       "#EAF2FC"
			},
			"Focus": {
				"Outline": "#9CC6F5"
			},
			"Shadow": {
				"Color": "rgba(0, 0, 0, 0.5)"
			},
			"Syntax": {
				"Keyword":     "#C678DD",
				"String":      "#98C379",
				"Number":      "#E5C07B",
				"Comment":     "#6E8AB3",
				"Operator":    "#56B6C2",
				"Punctuation": "#C7D9EF",
				"Function":    "#9CC6F5",
				"Variable":    "#E06C75",
				"Type":        "#E5C07B",
				"Builtin":     "#D19A66",
				"Property":    "#E06C75",
				"Tag":         "#E06C75",
				"AttrName":    "#D19A66",
				"AttrValue":   "#98C379"
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
				"Serif": "Georgia, Cambria, Times New Roman, Times, serif",
				"Mono": "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
				"Display": "'Gorton Perfected', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace"
			},
			"Display": {
				"Transform": "uppercase",
				"Tracking": "1.5px",
				"Weight": "700"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.45",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Shadow": {
			"SM": "0 1px 2px var(--theme-color-shadow-color)",
			"MD": "0 2px 6px var(--theme-color-shadow-color)",
			"LG": "0 6px 18px var(--theme-color-shadow-color)"
		},
		"ZIndex": {
			"Base": "0",
			"Dropdown": "100",
			"Sticky": "200",
			"Overlay": "900",
			"Modal": "1000",
			"Toast": "2000",
			"Tooltip": "3000"
		},
		"Duration": {
			"Fast": "100ms",
			"Normal": "200ms",
			"Slow": "400ms"
		}
	},
	"Brand": {
		"Name": "Plansheet",
		"Tagline": "Everything, drafted."
	}
}
